import type React from 'react';

export interface PanelProps {
	children: React.ReactNode;
	title?: string;
}

export const Panel = ({children, title}: PanelProps) => (
	<div className="panel">
		{title != null && title !== '' ? <h2>{title}</h2> : null}
		{children}
	</div>
);
